/* eslint-disable @typescript-eslint/ban-ts-ignore */
import cloneDeep from 'lodash/cloneDeep';
import { toPlainObject } from 'contentful-sdk-core';
export var wrapCollection = function wrapCollection(fn) {
  return function (http, data) {
    var collectionData = toPlainObject(cloneDeep(data)); // @ts-ignore

    collectionData.items = collectionData.items.map(function (entity) {
      return fn(http, entity);
    }); // @ts-ignore

    return collectionData;
  };
};
export var VersionHeader = function VersionHeader(version) {
  return {
    headers: {
      'X-Contentful-Version': Number.isInteger(version) ? version : 0
    }
  };
};